import { createTheme, ThemeProvider } from '@mui/material'
import React, { createContext, useContext, useState } from 'react'
import { defaultComponentLevelTheme, defaultTheme } from '../theme/defaultThemes'
import { grey } from '@mui/material/colors'

const ThemeContext = createContext()

export const ThemeProviderContext = ({ children }) => {
  const [theme, setTheme] = useState(createTheme(defaultTheme))

  const updateTheme = (primaryColor, secondaryColor) => {
    const newTheme = createTheme(updateAndReturnTheme(primaryColor, secondaryColor))
    setTheme(newTheme)
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme: updateTheme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  )
}

export const useCustomTheme = () => useContext(ThemeContext)

export const updateAndReturnTheme = (primaryColor, secondaryColor) => ({
  palette: {
    primary: { main: primaryColor || '#6C47E4' },
    secondary: { main: secondaryColor || '#27104E' },
    info: { main: grey[700] },
    tertiary: { main: grey || '#b6b6b6' },

    text: {
      primary: '#27104e',
      secondary: '#656d92',
      error: '#FF0000',
      warning: '#FFCC00',
      white: '#fff',
    },
    avatar: {
      bg: '#554400',
    },
    border: {
      primary: '#6C47E4',
      secondary: '#DEE2E6',
      tertiary: '#888888',
    },
  },
  typography: {
    fontFamily: 'Plus Jakarta Sans',
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    fontSize: 14,
  },
  components: defaultComponentLevelTheme,
})
